module.exports = __webpack_public_path__ + "static/img/dj.fcb1aaf1.gif";